import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconGeniusProps } from './IconGenius.types'
import * as Styled from './styles/IconGenius.style'

import { nonThemeableRules } from '../../ruleSet'

const IconGenius: FC<IconGeniusProps> = ({
  size = nonThemeableRules.defaultSize as number as IconGeniusProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconGeniusProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M14.184 4.793c.714 1.742 1.171 4.332 1.171 7.207 0 5.25-1.5 9.5-3.355 9.5-1.852 0-3.352-4.25-3.352-9.5s1.5-9.5 3.352-9.5c.29.008.57.102.8.273m4.477 16.368.52-.028c.344-.02.668-.16.922-.394 1.308-1.313-.637-5.375-4.348-9.09-3.71-3.715-7.777-5.656-9.09-4.348-1.308 1.313.637 5.38 4.344 9.094 1.969 1.969 4.04 3.441 5.75 4.195l.469.2M12 8.648c5.25 0 9.5 1.5 9.5 3.352 0 1.852-4.25 3.352-9.5 3.352S2.5 13.852 2.5 12c0-1.852 4.25-3.352 9.5-3.352Zm-6.75 7.114.219-.465c.765-1.692 2.222-3.727 4.156-5.672 3.71-3.71 7.777-5.656 9.09-4.348 1.308 1.313-.633 5.383-4.34 9.098-3.707 3.715-7.777 5.656-9.09 4.348a1.523 1.523 0 0 1-.41-1.012l-.016-.527m.18-1.454a.74.74 0 1 1-.742.739c0-.196.078-.383.215-.524a.722.722 0 0 1 .527-.215Zm0 .364a.375.375 0 1 1 0 .75.375.375 0 0 1 0-.75Zm11.512 2.148a.742.742 0 1 1 0 1.485.741.741 0 0 1-.524-1.266.74.74 0 0 1 .524-.219Zm0 .367a.375.375 0 1 1 0 .75.375.375 0 0 1 0-.75ZM13.699 2.906a.742.742 0 1 1 0 1.484.742.742 0 0 1 0-1.484Zm0 .367a.375.375 0 1 1 0 .75.375.375 0 0 1 0-.75Zm-.898-.5.426.305m.957 1.715-.196-.465'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconGenius
